<template>
  <div class="card vh-75" id="scroll">
      <h3 class="m-3">Our Trades</h3>
      <div class="table-responsive">
      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
      <table class="table align-items-center table-flush table-hover bidtbl">
          <thead class="thead-light psticky">
          <tr>
              <th 
                  scope="col" 
                  class="sort text-center"
                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'accountNo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'accountNo'  ? 'sort-desc' : '']"  
                  @click="sort('accountNo')" >ACCOUNT <br> NO</th>
              <th
                scope="col" 
                class="sort text-center"
                >BUY/SELL </th> 
                <th 
                  scope="col" 
                  class="sort text-center"
                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tradeDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tradeDate'  ? 'sort-desc' : '']"  
                  @click="sort('tradeDate')" >TRADE <br> DATE</th>  
              <th 
                  scope="col" 
                  class="sort text-center"
                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                  @click="sort('quantity')" >QTY</th>
              <th 
                  scope="col" 
                  class="sort text-center"
                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                  @click="sort('price')" >PRICE</th> 
              
              <th 
                  scope="col" 
                  class="sort text-center"
                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'fbsiShortName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'fbsiShortName'  ? 'sort-desc' : '']"  
                  @click="sort('fbsiShortName')" >Owner</th> 
            
          </tr>
          </thead>
          <tbody class="list no-cursor">
          <tr v-if="totalRows == 0 && !loading">
              <td><p class="nodata">No data available</p>
              </td>
          </tr>
          <tr v-for="data in PlList" :key="data.id" v-bind:class="{'row-highlight-red' : data.highlight}">
              <td class="text-center">{{data.accountNo}}</td>
              <td class="text-center">{{data.actionSb}}</td>
              <td class="text-center">{{moment(data.tradeDate).format("MM/DD/YYYY") }}</td>
              <td class="text-center">{{data.quantity}}</td>
              <td class="text-center">{{data.price | currency}}</td>
              <td class="text-center">{{data.owner}}</td>
          </tr>
          </tbody>
      </table>
      <!-- Pagination-->
      <b-pagination
          class="mt-4"
          :total-rows="totalRows"
          v-model="currentPage"
          :per-page="perPage"
          @input="getPLList(currentPage)"
      ></b-pagination>
      <div class="total-records">
          <span>Total Records : {{totalRows}}</span>
      </div>
      </div>
  </div>
</template>
  <script>
  import authService from "@/authService";
  import config from "@/config";
  export default {
    name: "imsPLComponentSells",
    components : {
    },
    props :["cusipId"],
    watch: { 
    cusipId: function() { // watch it
          this.getPLList();
        }
      },
    data() {
      return {
          loading : false,
          currentPage: 1,
          perPage: 10,
          totalRows : 0,
          sortColumn: "tradeDate",
          sortOrder: "DESC",
          PlList:[],
      };
    },
    methods: {
      sort(column){
          this.sortColumn = column;
          this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
          this.getPLList();
      },
      getPLList(){
        this.loading = true;
        const auth = {
          headers: {'org-token' : authService.getOrgToken() }
        };
        let url = "/autobidder/our-trades?";
        this.$http
          .get(
            config.baseUrlAutoBidder +
              url+"page=" +
              this.currentPage +
              "&size=" +
              this.perPage +
              "&sortColumn=" +
              this.sortColumn +
              "&sortOrder=" +
              this.sortOrder+
              "&cusip="+
              this.cusipId+
              "&cognitoSub="+
              authService.getUser().cognitoSub,
              auth
          )
          .then(result => {
            this.loading = false;
            this.totalRows = result.data.pageInfo.totalElements;
            this.PlList = result.data.content;
              
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    mounted() {
        this.getPLList();
    }
  };
  </script>